export default "__VITE_ASSET__DciVvT1h__"